// Docs:
// https://github.com/calvinmetcalf/leaflet-ajax
// https://github.com/stuartmatthews/leaflet-geotiff
// https://github.com/santilland/plotty
//
// To convert GeoJSON to GeoTIFF:
// gdal_rasterize -3d -ts 600 500 slopes.json slopes.tif
//
// To compare with other result:
// http://www.datapointed.net/visualizations/maps/san-francisco/streets-slope/

import 'leaflet-ajax';
import 'leaflet-geotiff';
import 'leaflet-geotiff/leaflet-geotiff-plotty';
import { L, initializeMap } from '../shared/map';

const ROADS_URL = '/data/slopes/roads.json';
const ROADS_OPTIONS = {
  weight: 0.5,
  style: {
    color: '#0f4fa8',
    opacity: 1,
  },
};

const DEM_URL = '/data/slopes/dem.tif';
const DEM_OPTIONS = {
  renderer: L.LeafletGeotiff.plotty({
    displayMin: -16,
    displayMax: 298,
    colorScale: 'viridis',
  }),
};

const SLOPES_URL = '/data/slopes/slopes.tif';
const SLOPES_OPTIONS = {
  renderer: L.LeafletGeotiff.plotty({
    displayMin: 0.0001,
    displayMax: 15,
    colorScale: 'viridis',
  }),
};

const SAN_FRANCISCO_VIEW = {
  center: [37.7649, -122.4294],
  zoom: 13,
};

const createLegendForDem = (dem, options = {}) => {
  const legend = L.control({ position: 'topright' });
  const { titleLabel, minLabel, maxLabel } = options;

  legend.onAdd = () => {
    const { renderer } = dem.options;

    if (!renderer) return null;

    const { displayMin, displayMax } = renderer.options;

    if (!displayMin || !displayMax) return null;

    const container = L.DomUtil.create('div', 'dem-legend');
    const title = L.DomUtil.create('div', 'dem-legend-title');
    const axis = L.DomUtil.create('div', 'dem-legend-axis');
    const min = L.DomUtil.create('span');
    const max = L.DomUtil.create('span');
    const palette = L.DomUtil.create('img', 'dem-legend-palette');

    title.innerText = titleLabel;
    min.innerText = minLabel || displayMin;
    max.innerText = maxLabel || displayMax;
    palette.src = renderer.colorScaleData;

    axis.append(min);
    axis.append(max);
    container.append(title);
    container.append(palette);
    container.append(axis);

    return container;
  };

  return legend;
};

document.addEventListener('DOMContentLoaded', () => {
  const rawDataMap = initializeMap('raw-data-map', SAN_FRANCISCO_VIEW);
  const rawDataDem = L.leafletGeotiff(DEM_URL, DEM_OPTIONS);
  const rawDataRoads = L.geoJson.ajax(ROADS_URL, ROADS_OPTIONS);
  const rawDataLegend = createLegendForDem(rawDataDem, {
    titleLabel: 'Elevation, meters',
  });

  rawDataRoads.addTo(rawDataMap);
  rawDataDem.addTo(rawDataMap);
  rawDataLegend.addTo(rawDataMap);

  const slopesDataMap = initializeMap('slopes-data-map', SAN_FRANCISCO_VIEW);
  const slopesData = L.leafletGeotiff(SLOPES_URL, SLOPES_OPTIONS);
  const slopesDataLegend = createLegendForDem(slopesData, {
    titleLabel: 'Slope, degrees',
    minLabel: '0',
    maxLabel: '15+',
  });

  slopesData.addTo(slopesDataMap);
  slopesDataLegend.addTo(slopesDataMap);
});
